import React from "react";
import { useTranslation } from "react-i18next";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import { JoinConditionValue, JoinCondition } from "@quest_editor/constants";

const JoinConditionField = ({
  joinCondition,
  setJoinCondition,
}: {
  joinCondition: JoinConditionValue;
  setJoinCondition: React.Dispatch<React.SetStateAction<JoinConditionValue>>;
}) => {
  const { t } = useTranslation("questEditor");

  const handleJoinConditionChange = (key: JoinConditionValue) => () => {
    setJoinCondition(key);
  };

  return (
    <FormControl>
      <FormLabel>
        {t("quest_edit_target.field.purchase.content.join_condition")}
      </FormLabel>
      <RadioGroup row>
        <FormControlLabel
          control={
            <Radio
              checked={joinCondition === JoinCondition.OR}
              onChange={handleJoinConditionChange(JoinCondition.OR)}
            />
          }
          label="OR"
          sx={{ color: "text.secondary" }}
        />
        <FormControlLabel
          control={
            <Radio
              checked={joinCondition === JoinCondition.AND}
              onChange={handleJoinConditionChange(JoinCondition.AND)}
            />
          }
          label="AND"
          sx={{ color: "text.secondary" }}
        />
      </RadioGroup>
    </FormControl>
  );
};

export default JoinConditionField;
